var l = Object.defineProperty;
var g = (e, t, n) => t in e ? l(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var i = (e, t, n) => g(e, typeof t != "symbol" ? t + "" : t, n);
import { S as r } from "../../index-LgiXwH_r.js";
import { GenericTypeStepBatchMutationHandler as d } from "./step-params-generic-type-batch-mutation-handler.js";
import { StepParamsGenericTypeHandler as a } from "./step-params-generic-type-handler.js";
import { ListTypeByParentStepHandler as u } from "./step-params-generic-type-list-by-parent-handler.js";
import { GenericTypeStepMutationHandler as c } from "./step-params-generic-type-mutation-handler.js";
import { StepParamsObjectSchemaHandler as s } from "./step-params-object-schema-handler.js";
import { StepParamsOneOfSchemaHandler as m } from "./step-params-one-of-schema-handler.js";
import { LogicStepHandler as h } from "./step-params-logic-handler.js";
import { CloudFunctionStepHandler as f } from "./step-params-cloud-function-handler.js";
import { GenericAIStepHandler as b } from "./step-params-generic-ai-handler.js";
const T = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    ofType: {
      type: "string"
    },
    namespace: {
      type: "string"
    },
    input: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: {
            type: "string"
          },
          fields: {
            type: "object"
          },
          directives: {
            type: "array",
            items: {
              type: "string"
            }
          },
          connections: {
            type: "object",
            properties: {
              first: {
                type: "object",
                properties: {
                  with: {
                    type: "string"
                  },
                  link: {
                    type: "string"
                  }
                }
              },
              second: {
                type: "object",
                properties: {
                  with: {
                    type: "string"
                  },
                  link: {
                    type: "string"
                  }
                }
              }
            }
          }
        },
        required: ["ofType"]
      }
    }
  }
}, S = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    ids: {
      type: "array",
      items: {
        type: "string"
      }
    },
    ofType: {
      type: "string"
    },
    namespace: {
      type: "string"
    }
  },
  required: ["ids", "ofType"]
}, j = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    ofType: {
      type: "string"
    },
    fields: {
      type: "object"
    },
    namespace: {
      type: "string"
    },
    directives: {
      type: "array",
      items: {
        type: "string"
      }
    },
    connections: {
      type: "object"
    }
  },
  required: ["ofType"]
}, _ = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    ofType: {
      type: "string"
    },
    namespace: {
      type: "string"
    }
  },
  required: ["id", "ofType"]
}, P = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    text: {
      type: "string"
    },
    model: {
      type: "string",
      enum: [
        "eleven_monolingual_v1",
        "eleven_multilingual_v1",
        "eleven_multilingual_v2",
        "eleven_turbo_v2",
        "eleven_turbo_v2_5",
        "eleven_flash_v2",
        "eleven_flash_v2_5"
      ]
    },
    stream: {
      type: "boolean"
    },
    outputFormat: {
      type: "string"
    },
    voiceId: {
      type: "string"
    },
    apiKey: {
      type: "string"
    },
    similarityBoost: {
      type: "number"
    },
    stability: {
      type: "number"
    },
    style: {
      type: "number"
    }
  },
  required: ["text"]
}, x = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    url: {
      type: "string"
    }
  }
}, I = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    searchTerms: {
      type: "string"
    },
    searchEngineId: {
      type: "string"
    },
    lang: {
      type: "string",
      enum: [
        "lang_ar",
        "lang_bg",
        "lang_ca",
        "lang_cs",
        "lang_da",
        "lang_de",
        "lang_el",
        "lang_en",
        "lang_es",
        "lang_et",
        "lang_fi",
        "lang_fr",
        "lang_hr",
        "lang_hu",
        "lang_id",
        "lang_is",
        "lang_it",
        "lang_iw",
        "lang_ja",
        "lang_ko",
        "lang_lt",
        "lang_lv",
        "lang_nl",
        "lang_no",
        "lang_pl",
        "lang_pt",
        "lang_ro",
        "lang_ru",
        "lang_sk",
        "lang_sl",
        "lang_sr",
        "lang_sv",
        "lang_tr",
        "lang_zh-CN",
        "lang_zh-TW"
      ]
    },
    apiKey: {
      type: "string"
    },
    numOfResults: {
      type: "integer"
    },
    searchType: {
      type: "string",
      enum: ["image"]
    },
    siteSearch: {
      type: "string"
    },
    siteSearchFilter: {
      type: "string",
      enum: ["exclude", "include"]
    },
    dateRestrict: {
      type: "string"
    }
  },
  required: ["searchTerms"]
}, $ = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    htmlString: {
      type: "string"
    },
    outputFilename: {
      type: "string"
    },
    format: {
      type: "string",
      enum: [
        "letter",
        "legal",
        "tabloid",
        "ledger",
        "a0",
        "a1",
        "a2",
        "a3",
        "a4",
        "a5",
        "a6"
      ]
    },
    margin: {
      type: "object",
      properties: {
        top: {
          type: "string"
        },
        right: {
          type: "string"
        },
        bottom: {
          type: "string"
        },
        left: {
          type: "string"
        }
      }
    }
  },
  required: ["htmlString"]
}, v = {
  $schema: "http://json-schema.org/draft-07/schema#",
  definitions: {
    url: {
      type: "string",
      format: "uri"
    },
    parameters: {
      type: "object",
      additionalProperties: {
        type: "string"
      }
    },
    headers: {
      type: "object",
      additionalProperties: {
        type: "string"
      }
    },
    contentMediaType: {
      type: "string",
      enum: [
        "application/json",
        "text/plain",
        "application/xml",
        "application/x-www-form-urlencoded",
        "multipart/form-data"
      ]
    }
  },
  oneOf: [
    {
      type: "object",
      properties: {
        httpMethod: {
          type: "string",
          enum: ["GET", "DELETE"]
        },
        url: {
          $ref: "#/definitions/url"
        },
        parameters: {
          $ref: "#/definitions/parameters"
        },
        headers: {
          $ref: "#/definitions/headers"
        },
        contentMediaType: {
          $ref: "#/definitions/contentMediaType"
        }
      },
      required: ["httpMethod", "url"]
    },
    {
      type: "object",
      properties: {
        httpMethod: {
          enum: ["POST", "PUT", "PATCH"]
        },
        url: {
          $ref: "#/definitions/url"
        },
        parameters: {
          $ref: "#/definitions/parameters"
        },
        headers: {
          $ref: "#/definitions/headers"
        },
        contentMediaType: {
          $ref: "#/definitions/contentMediaType"
        },
        body: {
          type: "string"
        }
      },
      required: ["body", "httpMethod", "url"]
    }
  ],
  routingParams: ["httpMethod"]
}, C = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    websiteUrl: {
      type: "string"
    },
    selectors: {
      type: "string"
    },
    resultType: {
      type: "string",
      enum: ["text", "html"]
    },
    numOfResults: {
      type: "integer"
    }
  },
  required: ["websiteUrl"]
}, H = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    ofType: {
      type: "string"
    },
    limit: {
      type: "number"
    },
    nextToken: {
      type: "string"
    },
    sortOrder: {
      type: "string",
      enum: ["ASC", "DESC"]
    },
    namespace: {
      type: "string"
    }
  },
  required: ["ofType"]
}, q = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    record: {
      type: "object",
      additionalProperties: {
        type: "object",
        properties: {
          id: {
            type: "string"
          },
          ofType: {
            type: "string"
          },
          namespace: {
            type: "string"
          },
          connections: {
            type: "object",
            properties: {
              first: {
                type: "object",
                properties: {
                  with: {
                    type: "string"
                  },
                  link: {
                    type: "string"
                  }
                }
              },
              second: {
                type: "object",
                properties: {
                  with: {
                    type: "string"
                  },
                  link: {
                    type: "string"
                  }
                }
              }
            }
          }
        }
      }
    },
    operation: {
      type: "string",
      enum: ["INSERT", "UPDATE", "DELETE"]
    }
  },
  required: []
}, M = {
  $schema: "http://json-schema.org/draft-07/schema#",
  definitions: {
    IChatCompletionContentPartImage: {
      type: "object",
      properties: {
        image_url: {
          type: "object",
          properties: {
            url: {
              type: "string"
            },
            detail: {
              type: "string",
              enum: ["auto", "low", "high"]
            }
          },
          required: ["url"]
        },
        type: {
          type: "string",
          enum: ["image_url"]
        }
      },
      required: ["image_url", "type"]
    },
    IChatCompletionContentPart: {
      type: "object",
      properties: {
        text: {
          type: "string"
        },
        type: {
          type: "string",
          enum: ["text"]
        }
      },
      required: ["text", "type"]
    },
    ISystemMessageParam: {
      type: "object",
      properties: {
        content: {
          type: "string"
        },
        role: {
          type: "string",
          enum: ["system"]
        }
      },
      required: ["content", "role"]
    },
    UserMessageParam: {
      type: "object",
      properties: {
        content: {
          oneOf: [
            {
              type: "string"
            },
            {
              type: "array",
              items: {
                oneOf: [
                  {
                    $ref: "#/definitions/IChatCompletionContentPart"
                  },
                  {
                    $ref: "#/definitions/IChatCompletionContentPartImage"
                  }
                ],
                routingParams: ["type"]
              }
            }
          ]
        },
        role: {
          type: "string",
          enum: ["user"]
        }
      },
      required: ["content", "role"]
    },
    IAssistantMessageParam: {
      type: "object",
      properties: {
        content: {
          type: "string"
        },
        role: {
          type: "string",
          enum: ["assistant"]
        }
      },
      required: ["content", "role"]
    },
    IMessageParam: {
      oneOf: [
        {
          $ref: "#/definitions/ISystemMessageParam"
        },
        {
          $ref: "#/definitions/UserMessageParam"
        },
        {
          $ref: "#/definitions/IAssistantMessageParam"
        }
      ],
      routingParams: ["role"]
    },
    IModel: {
      type: "string",
      enum: [
        "o1",
        "o1-mini",
        "o3-mini",
        "gpt-4-turbo",
        "gpt-4o",
        "gpt-4o-mini",
        "gpt-3.5-turbo"
      ]
    }
  },
  type: "object",
  properties: {
    model: {
      $ref: "#/definitions/IModel"
    },
    systemPrompt: {
      type: "object",
      properties: {
        basePrompt: {
          type: "string"
        },
        systemTools: {
          type: "string"
        },
        clientTools: {
          type: "string"
        },
        clientContext: {
          type: "string"
        }
      }
    },
    messages: {
      type: "array",
      items: {
        $ref: "#/definitions/IMessageParam"
      }
    },
    temperature: {
      type: "number"
    },
    apiKey: {
      type: "string"
    }
  },
  required: ["model", "messages"]
}, A = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    model: {
      type: "string",
      enum: [
        "text-embedding-3-large",
        "text-embedding-3-small",
        "text-embedding-ada-002"
      ]
    },
    input: {
      type: "string"
    },
    encoding_format: {
      type: "string",
      enum: ["float", "base64"]
    },
    dimensions: {
      type: "integer"
    },
    user: {
      type: "string"
    },
    apiKey: {
      type: "string"
    }
  },
  required: ["model", "input"]
}, E = {
  $schema: "http://json-schema.org/draft-07/schema#",
  oneOf: [
    {
      type: "object",
      properties: {
        model: {
          type: "string",
          enum: ["dall-e-3"]
        },
        prompt: {
          type: "string"
        },
        quality: {
          type: "string",
          enum: ["standard", "hd"]
        },
        size: {
          type: "string",
          enum: ["1024x1024", "1792x1024", "1024x1792"]
        },
        style: {
          type: "string",
          enum: ["vivid", "natural"]
        },
        outputFilename: {
          type: "string"
        },
        apiKey: {
          type: "string"
        }
      },
      required: ["prompt"]
    },
    {
      type: "object",
      properties: {
        model: {
          type: "string",
          enum: ["dall-e-2"]
        },
        prompt: {
          type: "string"
        },
        size: {
          type: "string",
          enum: ["256x256", "512x512", "1024x1024"]
        },
        n: {
          enum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        },
        outputFilename: {
          type: "string"
        },
        apiKey: {
          type: "string"
        }
      },
      required: ["prompt"]
    }
  ],
  routingParams: ["model"]
}, O = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    ofType: {
      type: "string"
    },
    namespace: {
      type: "string"
    }
  },
  required: ["id", "ofType"]
}, G = {
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {
    id: {
      type: "string"
    },
    ofType: {
      type: "string"
    },
    fields: {
      type: "object"
    },
    connections: {
      type: "object"
    },
    namespace: {
      type: "string"
    },
    directives: {
      type: "array",
      items: {
        type: "string"
      }
    }
  },
  required: ["id", "ofType"]
};
class k extends c {
  constructor(t) {
    super(j, t);
  }
}
class w extends c {
  constructor(t) {
    super(G, t);
  }
}
class L extends a {
  constructor() {
    super(_);
  }
}
class F extends a {
  constructor() {
    super(H);
  }
}
class U extends a {
  constructor() {
    super(S);
  }
}
class B extends a {
  constructor() {
    super(O);
  }
}
class R extends s {
  constructor() {
    super(M);
  }
}
class K extends s {
  constructor() {
    super(A);
  }
}
class D extends s {
  constructor() {
    super(P);
  }
}
class z extends s {
  constructor() {
    super($);
  }
}
class W extends m {
  constructor() {
    super(
      E,
      void 0,
      void 0,
      (t) => t.model
    );
  }
}
class N extends s {
  constructor() {
    super(I);
  }
}
class V extends s {
  constructor() {
    super(C);
  }
}
class J extends d {
  constructor(t) {
    super(T, t);
  }
}
class Q extends m {
  constructor() {
    super(v, void 0, !0, (t) => t.httpMethod);
  }
}
class X extends s {
  constructor() {
    super(q);
  }
}
class Y extends s {
  constructor() {
    super(x);
  }
}
class Z {
  constructor() {
    i(this, "schema", {});
  }
  getFieldLogicLanguage() {
    return "static";
  }
  getFieldLogicLanguageOptions() {
    return ["static"];
  }
  getFields() {
    return [];
  }
  getUpdatedState(t) {
    return t;
  }
  validate() {
    return !0;
  }
  getFieldValue(t, n) {
    return t[n];
  }
  getInitialState() {
    return {};
  }
  getUpdatedParamsConfigState(t) {
    return t;
  }
}
class ee extends s {
  constructor() {
    super({
      type: "object",
      properties: {
        lorem: {
          type: "string"
        },
        ipsum: {
          type: "object",
          properties: {
            lorem: {
              type: "string"
            },
            ipsum: {
              type: "object",
              properties: {
                lorem: {
                  type: "string"
                },
                ipsum: {
                  type: "string"
                }
              }
            },
            dolor: {
              type: "number"
            }
          }
        },
        dolor: {
          type: "string"
        }
      }
    });
  }
}
const p = class p {
  static create(t, n) {
    const y = p.map[t];
    return new y(n);
  }
};
i(p, "map", {
  [r.createType]: k,
  [r.updateType]: w,
  [r.deleteType]: L,
  [r.listTypeByParent]: u,
  [r.listType]: F,
  [r.batchGetType]: U,
  [r.type]: B,
  [r.batchCreateType]: J,
  [r.openAICompletion]: R,
  [r.openAIEmbeddings]: K,
  [r.elevenLabsTTS]: D,
  [r.htmlToPdf]: z,
  [r.openAIImageGeneration]: W,
  [r.logic]: h,
  [r.createFont]: Z,
  [r.notifyWebSocket]: X,
  [r.googleSearch]: N,
  [r.linkScraper]: V,
  [r.httpRequest]: Q,
  [r.extractImageMetadata]: Y,
  [r.cloudFunction]: f,
  [r.genericAI]: b,
  test: ee
});
let o = p;
const te = /* @__PURE__ */ new Set([
  "createType",
  "updateType",
  "deleteType",
  "listTypeByParent",
  "listType",
  "type",
  "batchGetType",
  "batchCreateType"
]), ge = (e) => te.has(e);
export {
  o as StepHandlerFactory,
  ge as isGenericTypeStep
};
